<template>
  <div ref="headerBannerTemplate" class="pdf-header-template-container">
    <div class="pdf-header-banner">
      
      <div class="pdf-header-left">
        <img 
          :src="logoSistemaUrl" 
          class="logo-sistema" 
          crossorigin="anonymous" 
          alt="SISCOL" 
        />
      </div>

      <div class="pdf-header-right">
        <img 
          v-if="logoEnteUrl" 
          :src="logoEnteUrl" 
          class="logo-ente" 
          crossorigin="anonymous" 
          alt="Goiás" 
        />
        <div v-else class="logo-ente-placeholder">
          <i class="fa fa-university" aria-hidden="true"></i>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Auth from '../../services/Auth.js';

export default {
  name: 'CabecalhoPdf',
  created(){
    this.auth = new Auth();
  },
  data() {
    return {}
  },
  computed: {
    usuario: function () {
      if (this.auth.usuario && this.auth.loggedIn()) {
        return this.auth.usuario;
      }
      return null;
    },

    // 1. Resolve a URL da API para todos os ambientes
    apiBaseUrl() {
      // desenvolvimento
      if (window.location.port === '8015') {
        return `${window.location.protocol}//${window.location.hostname}:3015`;
      }

      // produção/homologação
      return '';
    },

    // 2. Monta as URLs apontando para o Rails
    logoSistemaUrl() {
      return `${this.apiBaseUrl}/api/v1/logo_proxy?tipo=sistema`
    },

    logoEnteUrl() {
      return `${this.apiBaseUrl}/api/v1/logo_proxy?tipo=ente`
    }
  },
}
</script>


<style scoped>
.pdf-header-template-container {
  position: absolute;
  left: -9999px;
  width: 100%;
  max-width: 1008px;
  box-sizing: border-box;
  padding: 15px 0px;
  background-color: white;
}

.pdf-header-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1px;
}

.pdf-header-left {
  display: flex;
  align-items: center;
}

.logo-sistema {
  height: 85px;
  width: 120px;
  object-fit: contain;
}

.logo-ente {
  height: 145px;
  width: 135px;
  object-fit: fill;
}

.pdf-header-right {
  display: flex;
  align-items: center;
  gap: 18px;
}


.logo-ente-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #e2e8f0;
  border-radius: 50%;
  color: #718096;
  font-size: 18px;
  border: 2px solid #cbd5e0;
}
</style>
